import type { EmployeeViewModel } from '@trinnvis/dabih-api-client';

export function displayNameForEmployee(employees: { uuid: string; name: string }[], e: EmployeeViewModel): string {
  return employees.filter(function (employee) {
    return employee.uuid === e.uuid;
  })[0].name;
}
